import { render } from "./MemberLayout.vue?vue&type=template&id=922fc2de&scoped=true"
import script from "./MemberLayout.vue?vue&type=script&lang=js"
export * from "./MemberLayout.vue?vue&type=script&lang=js"

import "./MemberLayout.vue?vue&type=style&index=0&id=922fc2de&lang=css"
import "./MemberLayout.vue?vue&type=style&index=1&id=922fc2de&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922fc2de"]])

export default __exports__